// Volver a la página que se quería abrir después de iniciar sesión (p. ej.
// el enlace al informe de KPI del resumen mensual). Se guarda en
// localStorage, no en sessionStorage: el enlace mágico del email se abre en
// otra pestaña. Caduca a los 30 minutos y solo admite rutas internas de la
// app («/algo»), nunca otra web (sin redirecciones abiertas).
const KEY = "colygon_return_to";
const TTL_MS = 30 * 60 * 1000;

export const isSafePath = (path) =>
  typeof path === "string" && /^\/(?![/\\])/.test(path) && !/^\/(login|auth)(\/|$|\?)/.test(path);

export function rememberReturnTo(path) {
  if (!isSafePath(path) || path === "/") return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
  } catch {
    // almacenamiento no disponible (modo privado): se vuelve al inicio
  }
}

// Varias rutas del inicio de sesión navegan dos veces seguidas (el manejador
// y el efecto que reacciona al usuario): durante unos segundos tras la
// primera lectura se devuelve el mismo destino; después se olvida.
const GRACE_MS = 5000;

export function takeReturnTo(fallback = "/") {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!saved || !isSafePath(saved.path) || Date.now() - saved.at > TTL_MS) {
      localStorage.removeItem(KEY);
      return fallback;
    }
    if (saved.taken && Date.now() - saved.taken > GRACE_MS) {
      localStorage.removeItem(KEY);
      return fallback;
    }
    if (!saved.taken) localStorage.setItem(KEY, JSON.stringify({ ...saved, taken: Date.now() }));
    return saved.path;
  } catch {
    return fallback;
  }
}
